import { render } from "./Register.vue?vue&type=template&id=79f519ea&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=79f519ea&lang=scss&scoped=true"

import exportComponent from "F:\\unilearn\\unilearn-web-vue3\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f519ea"]])

export default __exports__